import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-navbar-item" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "gfu-navbar-btn gfu-navbar-btn--narrow",
      "aria-label": _ctx.Resources.Layout.LanguageSelectorTriggerLabel,
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.openModal && $options.openModal(...args)))
    }, [
      _createVNode(_component_base_image, {
        width: "28",
        class: "gfu-icon gfu-icon--elevate",
        src: $options.selectedLanguage.icon,
        alt: $options.selectedLanguage.value,
        "data-qa": "language-selector:FlagButton"
      }, null, 8 /* PROPS */, ["src", "alt"])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}